/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appAzureActiveDirectory_viewer$ref: FragmentReference;
declare export opaque type appAzureActiveDirectory_viewer$fragmentType: appAzureActiveDirectory_viewer$ref;
export type appAzureActiveDirectory_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +AADEnabled: ?boolean,
    +oneloginEnabled: ?boolean,
    +oktaEnabled: ?boolean,
    +scimUsernamePassword: ?string,
    +AADTenant: ?string,
    +AADClientId: ?string,
    +AADClientSecret: ?string,
  |},
  +$refType: appAzureActiveDirectory_viewer$ref,
|};
export type appAzureActiveDirectory_viewer$data = appAzureActiveDirectory_viewer;
export type appAzureActiveDirectory_viewer$key = {
  +$data?: appAzureActiveDirectory_viewer$data,
  +$fragmentRefs: appAzureActiveDirectory_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appAzureActiveDirectory_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scimUsernamePassword",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADTenant",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADClientId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADClientSecret",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '63c7529358c7a22c5cae0bcff0afeeee';

module.exports = node;
